import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BlockScreen from './block-screen';
import BlockScreenDeleteDialog from './block-screen-delete-dialog';
import BlockScreenDetail from './block-screen-detail';
import BlockScreenUpdate from './block-screen-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BlockScreenUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BlockScreenUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BlockScreenDetail} />
      <ErrorBoundaryRoute path={match.url} component={BlockScreen} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={BlockScreenDeleteDialog} />
  </>
);

export default Routes;
